import Swiper from 'swiper/js/swiper.min';

const scrollArtofLinks = Array.from(document.querySelectorAll('.j-artof-links'));
const optionsScrollMenuList = {
    wrapperClass: 'j-scroll-menu',
    slideClass  : 'j-scroll-menu-item',
    pagination  : {
        el               : '.j-multi-slider-pagination',
        bulletElement    : 'button',
        clickable        : true,
        bulletClass      : 'multi-slider__dot',
        bulletActiveClass: 'is-active'
    },
    slidesPerView: 'auto'
};

let swiper = null;

const swiperStatus = function() {
    if (window.innerWidth < 960 && scrollArtofLinks.length) {
        if (swiper) {
            swiper.forEach((element) => {
                return element.init();
            });
        } else {
            swiper = scrollArtofLinks.map((element) => {
                return new Swiper(element, optionsScrollMenuList);
            });
        }
    } else if (swiper) {
        swiper.forEach((element) => {
            return element.destroy();
        });
        swiper = null;
    }
};

swiperStatus();

window.addEventListener('resize', () => {
    swiperStatus();
});
